module.exports = __webpack_public_path__ + "img/energy_jienengfenxicesuan.7d64138e.png";